import type { FaireThemeEntity } from "../../entity_types/theme";

export const bespoke_and_custom_youth_apparel: FaireThemeEntity = {
  token: "bespoke-and-custom-youth-apparel",
  type: "theme",
  name: "Bespoke & Custom Youth Apparel",
  description: "Unique, high-quality youth shirts and sweatshirts that offer a personalized touch for parents looking for something beyond mass-market options.",
  teaser: "The retailer frequently orders kids' apparel, including babygowns, hoodies, and sweatshirts with specific graphics like 'Floral Smiley Face' and 'Born To Be Wild'.",
  detail: "The additional_context payload includes a specific search for 'custom shirt youth', suggesting an interest in personalized or niche youth clothing designs.",
  bgColor: "#D4D4FF",
  tileBgColor: "#6b5831",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_buvkfjy5wj",
    "p_2rz62645xn",
    "p_5e83k494kt",
    "p_mynm356qt9",
    "p_qrnvqu4han",
    "p_3cgv9mu7fc",
    "p_be84b94p4k",
    "p_bzvcsu372d",
    "p_9c8z6emz5c",
    "p_bcme6qq7x7",
    "p_v58y9erx46",
    "p_c8sp2vvxgw",
    "p_vd6znds2ja",
    "p_a6hkujpyap",
    "p_p7s7zp72wt",
    "p_93whrnags3",
    "p_f7gcp8akvz",
    "p_jj7jvzw2hb",
    "p_7j4zkbp3zt",
    "p_xv259r4ud8",
    "p_twfr8hzjjf",
    "p_3hfym99qqa",
    "p_2uz5b9at8y",
    "p_huxr8shjm9",
    "p_rundgrzsna",
    "p_6tygza284u",
    "p_42eubmgvzt",
    "p_6ps1z99hoa",
    "p_b50iydy1",
    "p_m6gj5v7n7b",
    "p_t7ppxujm6z",
    "p_qgxrpxk26d",
    "p_9wn3mmugaz",
    "p_492ug4jmbh",
    "p_j22kcbtvut",
    "p_d6d8tw85g3",
    "p_weu3cy5hf6",
    "p_37k3k2fctp",
    "p_d9gc6d3z2m",
    "p_a4fagdpccv",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
